import { Components } from "appworks/components/components";
import { State } from "appworks/state-machine/states/state";
import { FowlFlingBonusComponent } from "components/bonus/fling/fowl-fling-bonus-component";

export class FowlFlingBonusState extends State {
    public onEnter(cascadeSkip?: boolean): void {
        Components.get(FowlFlingBonusComponent).startPreLaunch();
        Components.get(FowlFlingBonusComponent).onComplete.addOnce(() => this.complete());
    }
}
